<template>
    <v-container fluid>
        <bank-account-form
            :model="bankAccount"
            @saved="saved"
            :titlePrefix="$t('bank-account.create.texts.title-prefix')"
            :reseller_id="reseller_id"
        ></bank-account-form>
    </v-container>
</template>

<script>
import BankAccountModel from '@/models/BankAccount'
import Reseller from '@/models/Reseller'
import BankAccountForm from './Form'

export default {
    props: {
        reseller_id: {
            required: true,
        },
    },

    components: {
        BankAccountForm,
    },

    data: () => {
        return {
            bankAccount: new BankAccountModel(),
        }
    },

    methods: {
        saved() {
            this.$router.push({ name: this.$t('bank-account.routes.index') })
        },

        async getReseller() {
            let resellerModel = new Reseller()
            this.reseller = await resellerModel.find(this.reseller_id)

            this.bankAccount.name = this.reseller.legal_name
            this.bankAccount.document = this.reseller.document
        },
    },

    created() {
        this.getReseller()
    },
}
</script>
